/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ProxyParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
]);
export class Proxy extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ProxyParser.decode(input).map(res => new Proxy(res));
    }
    static unsafeDecode(input) {
        return Proxy.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ProxyParser.encode(data);
    }
    static schema() {
        return ProxyParser.schema();
    }
}
